export enum AppSumoTierCoupons {
    TIER1 = "APPSUMOTIER1",
    TIER2 = "APPSUMOTIER2",
    TIER3 = "APPSUMOTIER3",
}

export const defaultFaviconUrl: string = `https://static.group.app/groups/favicons/mhrwdG6xwUg1GVgU69dtJtwT9yEcPNhwlEwgsMLe.png`
